import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  InfoClient,
  InfoCompany,
} from '../../../../interface/company-client.interface';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddNewContactComponent } from '../../../../modals/add-new-contact/add-new-contact.component';
import Swal from 'sweetalert2';
import { ActivatedRoute } from '@angular/router';
import { ContactInfoService } from '../../../../service/contact-info.service';
import { delay } from 'rxjs';

@Component({
  selector: 'app-list-contact',
  templateUrl: './list-contact.component.html',
  styleUrls: ['./list-contact.component.scss'],
})
export class ListContactComponent implements OnInit, OnChanges {
  @Input() infoClientTable!: InfoCompany;
  public dataSource: MatTableDataSource<InfoClient>;
  public rutUrl: number;
  @ViewChild(MatSort, { static: true }) sort: MatSort = Object.create(null);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator =
    Object.create(null);

  displayedColumns: string[] = [
    'Name',
    'Rut',
    'Phone',
    'Email',
    'InfoPreferences',
    'OriginRegister',
    'preferredContact',
  ];
  constructor(
    public dialog: MatDialog,
    private serviceInfo: ContactInfoService,
    private activateRouter: ActivatedRoute
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['infoClientTable'] && changes['infoClientTable'].currentValue) {
      const rut = this.infoClientTable.rut;
    if (rut) {      
      this.synchronize(rut);   // Sincronizar los datos sin delay
    }
    }
  }

  ngOnInit(): void {
    this.activateRouter.queryParams.subscribe((params: any) => {
      const { client } = params;
      const rut = parseInt(client);
      this.rutUrl = rut;
      this.getInfoClient(rut);
    });
  }

  private setDataSource(dataSource: InfoClient[]) {
    this.dataSource = new MatTableDataSource<InfoClient>(dataSource);
  }

  updateInfo(dataOwners: InfoClient) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = 'container_form_debts';

    dialogConfig.data = {
      isNew: false,
      data: dataOwners,
    };
    const dialogRef = this.dialog.open(AddNewContactComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res: boolean) => {
      if (res) this.getInfoClient(this.rutUrl);
    });
  }

  getInfoClient(rut: number) {
    this.serviceInfo.getInfoClientTable(rut).subscribe({
      next: (e) => this.setDataSource(e),
      complete() {},
    });
  }
  synchronize(rut: string) {
    this.serviceInfo.getContact(rut).subscribe({
      next: (e) => {
        console.log(e);
      },

      complete: () => {},
    });
  }

  addNewClient() {
    {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.panelClass = 'container_form_debts';
      dialogConfig.data = {
        isNew: true,
      };
      const dialogRef = this.dialog.open(AddNewContactComponent, dialogConfig);
      dialogRef.afterClosed().subscribe((res: boolean) => {
        if (res) {
          this.getInfoClient(this.rutUrl);
        }
      });
    }
  }

  deleteOwners(data: InfoClient) {
    Swal.fire({
      titleText: '¿ Eliminar este Contato ?',
      showCancelButton: true,
      heightAuto: false,
      showConfirmButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Confirmar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.serviceInfo.DeleteInfoClient(data.contactCompaniesId).subscribe({
          next: (res) => {
            Swal.fire({
              title: `Se ha eliminado exitosamente`,
              heightAuto: false,
              icon: 'success',
            }).then((result) => {
              if (result.isConfirmed) {
                this.getInfoClient(this.rutUrl);
              }
            });
          },
          error: (error) => {
            Swal.fire({
              title: `Ocurrio un problema al eliminar la relación`,
              icon: 'error',
              heightAuto: false,
            });
          },
        });
      }
    });
  }
}
